import React from 'react';

export interface CaseKeyContextType {
    unwrappedCaseKey: CryptoKey | null;
    encodedCaseKey: string;
}

export const CaseKeyContext = React.createContext({} as CaseKeyContextType);
